import { combineReducers } from 'redux'
import config from './configuration'
import userInfo from './userInfo'

const rootReducer = combineReducers({
                                      config,
                                      userInfo
                                    })
export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
